export var menuIcons = {
    support: require("./imgs/support-v2.svg"),
    supportV1: require('./imgs/support-life-ring.svg'),
    settingsV2: require('./imgs/settings-v2.svg'),
    menu: require("./imgs/menu.svg"),
    users: require("./imgs/users.svg"),
    dashboard: require("./imgs/dashboard.svg"),
    settings: require("./imgs/settings.svg"),
    quit: require("./imgs/quit.svg"),
    massOrder: require('./imgs/multi_task.svg'),
    myOrders: require("./imgs/mytasks.svg"),
    newOrder: require("./imgs/new-order.svg"),
    blog: require("./imgs/blog.svg"),
    api: require('./imgs/api-icon-v2.svg'),
    coin: require('./imgs/soccoin.svg'),
    moon: require('./imgs/moon.svg'),
    services: require("./imgs/services.svg"),
    tariff: require("./imgs/tariff.svg"),
    refill: require("./imgs/refill.svg"),
    socpanel: require("./imgs/socpanel.svg"),
    socpanelActive: require("./imgs/socpanel-hover.svg"),
    socpanelGrey: require("./imgs/socpanel-grey.svg"),
    socpanelOrange: require("./imgs/socpanel-orange.svg"),
    providers: require('./imgs/providers.svg'),
    paymentMethods: require('./imgs/payment-methods.svg'),
    appearance: require('./imgs/appearance.svg'),
    supportWallet: require('./imgs/support-wallet.svg'),
    wallet: require('./imgs/wallet.svg'),
    overview: require('./imgs/overview.svg'),
    checkedList: require('./imgs/checked-list.svg'),
    check: require('./imgs/check.svg'),
    pencil: require('./imgs/pencil.svg'),
    pencilV2: require('./imgs/pencil-v2.svg'),
    coins: require('./imgs/coins.svg'),
    coin: require('./imgs/coin.svg'),
    key: require('./imgs/key.svg'),
    notifications: require('./imgs/bell.svg'),
    balanceHistory: require('./imgs/history.svg'),
    bolt: require('./imgs/bolt.svg'),
    plusGray: require('./imgs/plus-gray.svg'),
    minus: require('./imgs/minus-gray.svg'),
    socgressGray: require('./imgs/socgress-gray.svg'),
    referral: require('./imgs/managers.svg'),
    swatchbook: require('./imgs/swatchbook.svg'),
    stats: require('./imgs/stats.svg'),
    serviceSettings: require('./imgs/service_settings.svg'),
    display: require('./imgs/display.svg'),
    home: require('./imgs/home.svg'),
    multiColorCheck: require('./imgs/multi-color-check.svg'),
    news: require('./imgs/news.svg'),
    shoppingBag: require('./imgs/shop-bag.svg'),
    send: require('@socgress/lib/support/static/send.svg'),
    remove: require('./imgs/remove.svg'),
    newspaper: require('./imgs/newspaper.svg'),
    trash: require('./imgs/trash.svg'),
    promoCode: require('./imgs/promo-codes.svg'),
    filters: require('./imgs/filters.svg'),
    bots: require('./imgs/bots.svg'),
    play: require('./imgs/play.svg'),
    partial: require('./imgs/partial.svg'),
    banned: require('./imgs/banned.svg'),
    fire: require('./imgs/fire.svg'),
    search: require('./imgs/search.svg'),
    searchIcon: require('./imgs/search-icon.svg'),
    favoriteAdd: require('./imgs/star.svg'),
    supportSubmit: require('@socgress/lib/support/static/send.svg'),
};
